<template>
  <div class="filter-items">
    <DropDown
      v-for="(filter, index) in filterConfig.filters"
      :key="index"
      :title="filter.title"
      :items="filter.items"
      :emit-event="filter.emitEvent"
      :is-single="filter.isSingle"
      v-on:[filter.emitEvent]="onFilterChange"
    />
  </div>
</template>

<script setup>
import DropDown from '../../DropDown.vue'
import { reactive, ref } from 'vue'

const hasLoaded = ref(false)

const props = defineProps({
    rawFilterConfig: {
        type: Object,
        required: true
    }
})

const filterConfig = reactive(JSON.parse(JSON.stringify(props.rawFilterConfig))) // deep clone


const emit = defineEmits()

function onFilterChange() {
    emit('on-filter-change', filterConfig)
}

defineExpose({
    setFilterOptions,
    reset
})

function getUniqueValuesClean(arr, field) {
    return [...new Set(
        arr.map(item => item[field]).filter(value => value != null)
    )];
}

function setFilterOptions(data) {
    if(filterConfig.filters) {
        filterConfig.filters.forEach((filter) => {
        if (filter.items.length > 0) { return }

        const uniqueValues = getUniqueValuesClean(data, filter.column)

        filter.items = uniqueValues.map((val) => ({
            name: val,
            value: true,
        }))
    })
    }
    
    hasLoaded.value = true
}
function reset() {
  if (!filterConfig.filters) return

  filterConfig.filters.forEach(filter => {
    if (!filter.isSingle) {
      // Multi-select: reset all to true
      filter.items.forEach(item => {
        item.value = true
      })
    } else {
      // Single-select: check if at least one is already true
      const hasActive = filter.items.some(item => item.value)

      if (!hasActive && filter.items.length > 0) {
        // If none are active, activate the first one
        filter.items.forEach((item, i) => {
          item.value = i === 0
        })
      }
      // If an item is already true, keep it
    }
  })

  onFilterChange()
}

</script>

<style scoped>
.filter-items {
    display: flex;
    gap: 8px;
}
</style>